import { Menu } from '@mui/material';

import type { Proposal } from 'api/projectVersioning/types';

import { ProposalMenuActions } from './ProposalMenuActions';

export type ProposalMenuProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  isInProposal: boolean;
  onCreateProposal: () => void;
  onMergeProposal: () => void;
  onDiscardProposal: () => void;
  onSeeAllProposals: () => void;
  onReviewChanges: () => void;
  viewLiveUrl: string;
  proposals: Proposal[];
  disabled?: boolean;
  loading?: boolean;
};

export const ProposalMenu: React.FC<ProposalMenuProps> = ({
  open,
  anchorEl,
  isInProposal,
  onClose,
  onCreateProposal,
  onMergeProposal,
  onDiscardProposal,
  onSeeAllProposals,
  onReviewChanges,
  viewLiveUrl,
  proposals,
  disabled,
  loading
}: ProposalMenuProps) => {
  return (
    <Menu
      id='proposal-menu'
      data-testid='proposal-menu'
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      slotProps={{
        paper: {
          sx: { minWidth: 160 }
        }
      }}
      onClick={onClose}
    >
      <ProposalMenuActions
        isInProposal={isInProposal}
        onCreateProposal={onCreateProposal}
        onMergeProposal={onMergeProposal}
        onDiscardProposal={onDiscardProposal}
        onSeeAllProposals={onSeeAllProposals}
        onReviewChanges={onReviewChanges}
        viewLiveUrl={viewLiveUrl}
        proposals={proposals}
        disabled={disabled}
        loading={loading}
      />
    </Menu>
  );
};
